import { render } from "./fundDetail.vue?vue&type=template&id=05113b0b&scoped=true"
import script from "./fundDetail.vue?vue&type=script&lang=js"
export * from "./fundDetail.vue?vue&type=script&lang=js"

import "./fundDetail.vue?vue&type=style&index=0&id=05113b0b&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05113b0b"]])

export default __exports__